export * from './Illustration';
export type { IllustrationProps } from './Illustration';

export { SceneWaving, SceneThumbsUp, SceneCoin, SceneJetpack } from './Scene';
export {
  HeroAuth,
  HeroNotFound,
  HeroPending,
  HeroProject,
  HeroSearch,
  HeroWelcome,
} from './Hero';
export {
  MediumBegin,
  MediumProgress,
  MediumReconcile,
  MediumRelax,
  MediumReview,
  MediumSupport,
  MediumUpgrade,
  MediumDowngrade,
  MediumReport,
} from './Medium';
export {
  SpotAppreciate,
  SpotAttention,
  SpotCaution,
  SpotCelebrate,
  SpotNoResults,
  SpotWave,
} from './Spot';
